// src/pages/PrivacyPolicyPage.jsx
import React from 'react';
import Breadcumb from '../components/Breadcumb';
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';
import privacyBanner from "../assets/img/privacy-banner.jpg"; // optional

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Breadcumb pageTitle="Privacy Policy" backgroundImage={privacyBanner} />
      <PrivacyPolicy />
    </div>
  );
};

export default PrivacyPolicyPage;